<template>
  <div>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="wareSelect" class="demo-form-inline">
        <el-form-item label="仓房选择">
          <el-select v-model="wareSelect.wareId" @change='wareIdChange' placeholder="仓房选择">
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <div class='setTabView' :style="`height:${height-50}px;width:${width-60}px`">
            <el-tabs v-model="activeName" type="card" class='delmarg'>
              <el-tab-pane label="数据表格" name="tab1">
                <div class='grainWrap' :style="`height:${height-90}px;width:${width-60}px`">
                  <div class='checkLayerWrap'>
                    <el-form :inline="true" class="demo-form-inline" v-if='wareSelect.wareType==0'>
                      <el-form-item label="选择层">
                        <el-select placeholder="选择层"  v-model='activeLayer'>
                          <el-option :label="item.name" :value="item.ind"  v-for='item in grainLayerList' :key='item.ind'></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div class='unitTips'>单位：℃</div>
                  <div v-if='wareSelect.wareType==0'>
                    <div class='grainDataTable allGrain' :style="`height:${height-140}px`" v-if='activeLayer==0'>
                      <div class='cengWrap' v-for='(item,index) in pointList' :key='index'>
                        <div class='ceng layerTitle'>第{{index+1}}层</div>
                        <div class='ceng'>
                          <div class='hang'>
                            <div class='lie' :style='`width:${(width-370)/(item[0].length+1)}px`'>行/列</div>
                            <div class='lie' v-for='(lie,index) in item[0]' :key='index' :style='`width:${(width-370)/(item[0].length+1)}px`'>第{{index+1}}列</div>
                          </div>
                          <div class='hang' v-for='(row,index) in item' :key='index'>
                            <div class='lie' :style='`width:${(width-370)/(row.length+1)}px`'>第{{index+1}}行</div>
                            <div class='lie' :style='`width:${(width-370)/(row.length+1)}px;cursor: pointer;`' v-for='(point,index) in row' :key='index' @click='getLineInfo(point.detailId)'>{{point.value}}</div>
                          </div>
                        </div> 
                      </div>
                    </div>
                    <div class='grainDataTable layerGrain' :style="`height:${height-140}px`" v-else>
                      <div class='cengWrap'>
                        <div class='ceng layerTitle'>第{{activeLayer}}层</div>
                        <div class='ceng'>
                          <div class='hang'>
                            <div class='lie' :style='`width:${(width-370)/(pointList[0][0].length+1)}px`'>行/列</div>
                            <div class='lie' v-for='(item,index) in pointList[0][0]' :key='index' :style='`width:${(width-370)/(pointList[0][0].length+1)}px`'>第{{index+1}}列</div>
                          </div>
                          <div class='hang' v-for='(item,index) in pointList[activeLayer-1]' :key='index'>
                            <div class='lie' :style='`width:${(width-370)/(item.length+1)}px`'>第{{index+1}}行</div>
                            <div class='lie' :style='`width:${(width-370)/(item.length+1)}px;cursor: pointer;`' v-for='(point,index) in item' :key='index' @click='getLineInfo(point.detailId)'>{{point.value}}</div>
                          </div>
                        </div> 
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class='grainDataTable siloGrain' :style="`height:${height-140}px`">
                      <div class='siloCengWrap' v-if='pointList[0]'>
                        <div class='hang'>
                          <div class='lie' :style='`width:${(width-100)/(siloGen+1)}px;height:80px`'>层/根/圈</div>
                          <div>
                            <div class='hang'>
                              <div class='siloTabTitle layerTitle' v-for='index in siloQuan' :key='index' :style='`width:${setLieWidth*pointList[0][index-1].length}px`'>第{{index}}圈</div>
                            </div>
                            <div class='hang'>
                              <div class='lie' v-for='ind in siloGen' :key='ind' :style='`width:${(width-100)/(siloGen+1)}px`'>第{{ind}}根</div>
                            </div>
                          </div>
                        </div>
                        <div class='hang' v-for='(ceng,index) in pointList' :key='index'>
                          <div class='lie' :style='`width:${(width-100)/(siloGen+1)}px`'>第{{index+1}}层</div>
                          <div v-for='(quan,index) in ceng' :key='index' class='siloQuan'>
                            <div class='lie' v-for='(point,index) in quan' :key='index' :style='`width:${(width-100)/(siloGen+1)}px;cursor: pointer;`' @click='getLineInfo(point.detailId)'>{{point.value}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="三维视图" name="tab2">
                <div class='grainWrap' :style="`height:${height-90}px`">
                  <div class="grain3DWrap">
                    <div class='check3DLayerWrap'>
                      <el-form :inline="true" class="demo-form-inline">
                        <el-form-item label="选择层">
                          <el-select placeholder="选择层"  v-model='activeLayer'>
                            <el-option :label="item.name" :value="item.ind"  v-for='item in grainLayerList' :key='item.ind'></el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </div>
                    <div class="ware3DWrap" :style="`transform:rotateY(${leavalY}deg) rotateX(${leavalX}deg);`" v-if='wareSelect.wareType==0' @mousedown="startDrag($event)">
                      <div class="wareLeftfront"></div>
                      <div class="wareLeftleft"></div>
                      <div class="wareLeftright"></div>
                      <div class="wareLefttop"></div>
                      <div class="wareBackfront"></div>
                      <div class="wareBackright"></div>
                      <div class="wareBacktop"></div>
                      <div class="wareBottomtop"></div>
                      <div class="wareBottombottom"></div>
                      <div class="wareBottomfront"></div>
                      <div class="wareBottomleft"></div>
                      <div class="wareBottomright"></div>
                      <div class="wareRightfront"></div>
                      <div class="wareRightright"></div>
                      <div class="wareRighttop"></div>
                      <div :class='["wareDataShow",activeLayer==0||activeLayer==(ind+1)?"isTempDataShow":""]' v-if='activeLayer==0||activeLayer==(ind+1)' :style='`transform: rotateX(90deg) translateX(10px) translateY(5px) translateZ(${200-(400/pointList.length)*(0.5+ind)}px);`' v-for='(item,ind) in pointList' :key='`ind${ind}`'>
                        <div class='dataShowGen' v-for='(gen,index) in item' :key='index'>
                          <div class='dataShowLie' v-for="(lie,index) in gen" :key='index'>
                            <div class="dataShowValue" style="background-color:#9eacb9;cursor: pointer;" @click='getLineInfo(lie.detailId)'>{{lie.value}}</div>
                          </div>
                        </div>
                      </div>
                      <div :class='["wareDataShow",activeLayer==0||activeLayer==(i+1)?"isTempDataShow":""]' v-if='activeLayer==0||activeLayer==(i+1)' :style='`transform: rotateX(90deg) translateX(10px) translateY(5px) translateZ(${200-(400/pointList.length)*(0.5+i)-10}px);`' v-for='(item,i) in pointList' :key='`i${i}`'></div>
                      <div :class='["wareDataShowfront",activeLayer==0||activeLayer==(index+1)?"iswareDataShowfront":""]' v-if='activeLayer==0||activeLayer==(index+1)' :style='`transform: translateZ(200px) translateX(10px) translateY(${(400/pointList.length)*(0.5+index)-5}px)`' v-for='(item,index) in pointList' :key='index'></div>
                      <div :class='["wareDateShowright",activeLayer==0||activeLayer==(index+1)?"iswareDataShowright":""]' v-if='activeLayer==0||activeLayer==(index+1)' :style='`transform: rotateY(-90deg) translateZ(-490px) translateY(${(400/pointList.length)*(0.5+index)-5}px)`'  v-for='(item,index) in pointList' :key='`index${index}`'></div>
                      <div class="wareCengWrap">
                        <div class="wareCengItem" v-for='(item,index) in pointList' :key='index'>第{{index+1}}层</div>
                      </div>
                      <div class="wareLieWrap" v-if='pointList[0]'>
                        <div class="wareLieItem" v-for='(item,index) in pointList[0][0]' :key='index'>第{{index+1}}列</div>
                      </div>
                      <div class="wareHangWrap">
                      <div class="wareHangItem" v-for='(item,index) in pointList[0]' :key='index'>第{{index+1}}行</div>
                      </div>
                    </div>
                    <div class='silo3DWrap' :style="`transform:rotateZ(${leavalY}deg) rotateX(${leavalX}deg);`" v-else @mousedown="startDrag($event)">
                      <div class="siloWall" v-for='index in 36' :key='index' :style='`transform:rotateY(${index*5}deg);`'></div>
                      <div class="siloBottom" :style='`transform: rotateX(90deg) translateZ(${-150+index}px);`' v-for='index in 5' :key='`index${index}`'></div>
                      <div class="siloBottom siloTop" style='transform: rotateX(90deg) translateZ(250px);'></div>
                      <div class='siloBottom siloDataShow' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+index)}px);`' v-for='(ceng,index) in pointList' :key='`silo${index}`' v-if='activeLayer==0||activeLayer==(index+1)'>
                        <div class='siloDataShowWarp'>
                          <div class='siloDataQuanWrap' v-for='(quan,quanInd) in ceng' :key='quanInd' :style='`z-index:${100-quanInd*5}`'>
                            <div class='siloDataQuan' :style='`width:${(500/ceng.length)*quanInd}px;height:${(500/ceng.length)*quanInd}px;z-index:${100-quanInd};}`'>
                              <div class="siloDataLie" v-for='(lie,index) in quan' :key='`lie${index}`' @click='getLineInfo(lie.detailId)' :style='`background-color:#9eacb9;cursor: pointer;transform: rotate(${(360/quan.length)*index}deg);transform-origin: 25px ${(250/ceng.length)*quanInd+25}px;`'>
                                <div>{{lie.value}}</div>
                                <div style='font-size:12px'>第{{lie.gen}}根</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==1?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5)-ind}px);`' v-for='ind in 5' :key='`bot1${ind}`' v-if='pointList.length>=1'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==2?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+1)-ind}px);`' v-for='ind in 5' :key='`bot2${ind}`' v-if='pointList.length>=2'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==3?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+2)-ind}px);`' v-for='ind in 5' :key='`bot3${ind}`' v-if='pointList.length>=3'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==4?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+3)-ind}px);`' v-for='ind in 5' :key='`bot4${ind}`' v-if='pointList.length>=4'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==5?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+4)-ind}px);`' v-for='ind in 5' :key='`bot5${ind}`' v-if='pointList.length>=5'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==6?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+5)-ind}px);`' v-for='ind in 5' :key='`bot6${ind}`' v-if='pointList.length>=6'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==7?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+6)-ind}px);`' v-for='ind in 5' :key='`bot7${ind}`' v-if='pointList.length>=7'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==8?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+7)-ind}px);`' v-for='ind in 5' :key='`bot8${ind}`' v-if='pointList.length>=8'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==9?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+8)-ind}px);`' v-for='ind in 5' :key='`bot9${ind}`' v-if='pointList.length>=9'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==10?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+9)-ind}px);`' v-for='ind in 5' :key='`bot10${ind}`' v-if='pointList.length>=10'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==11?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+10)-ind}px);`' v-for='ind in 5' :key='`bot11${ind}`' v-if='pointList.length>=11'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==12?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+11)-ind}px);`' v-for='ind in 5' :key='`bot12${ind}`' v-if='pointList.length>=12'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==13?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+12)-ind}px);`' v-for='ind in 5' :key='`bot13${ind}`' v-if='pointList.length>=13'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==14?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+13)-ind}px);`' v-for='ind in 5' :key='`bot14${ind}`' v-if='pointList.length>=14'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==15?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+14)-ind}px);`' v-for='ind in 5' :key='`bot15${ind}`' v-if='pointList.length>=15'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==16?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+15)-ind}px);`' v-for='ind in 5' :key='`bot16${ind}`' v-if='pointList.length>=16'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==17?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+16)-ind}px);`' v-for='ind in 5' :key='`bot17${ind}`' v-if='pointList.length>=17'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==18?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+17)-ind}px);`' v-for='ind in 5' :key='`bot18${ind}`' v-if='pointList.length>=18'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==19?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+18)-ind}px);`' v-for='ind in 5' :key='`bot19${ind}`' v-if='pointList.length>=19'></div>
                      <div :class='["siloBottom",activeLayer==0||activeLayer==20?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+19)-ind}px);`' v-for='ind in 5' :key='`bot20${ind}`' v-if='pointList.length==20'></div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择时间"
      :visible.sync="showDatePicker"
      :custom-class='"dialog-setBg"'>
      <div class="dialog-setWrap pickerWrap">
        <div>
          开始时间：
          <el-date-picker
            v-model="wareSelect.beginTime"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="startPickerOpts"
            placeholder="开始时间">
          </el-date-picker>
        </div>
        <div>
          结束时间：
          <el-date-picker
            v-model="wareSelect.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="endPickerOpts"
            placeholder="结束时间">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDatePicker=false">取 消</el-button>
        <el-button type="primary" @click="sureRangTime">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="单点曲线图"
      :visible.sync="showLineInfo"
      :custom-class='"dialog-setBg lineInfoCard"'>
      <div class="dialog-setWrap lineInfoWrap">
        <div ref='lineTempShow' class='echartLineWrap'></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLineInfo=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      activeName:'tab1',
      wareSelect:{
        wareId:'',
        wareType:'',
        beginTime:'',
        endTime:''
      },
      wareList:[],
      pointList:[],
      grainLayerList:[],
      siloGen:0,
      siloQuan:0,
      activeLayer:0,
      leavalX:0,
      leavalY:0,
      showDatePicker:false,
      lineTempShow:'',
      showLineInfo:false,
      startPickerOpts:{
        disabledDate:(t)=>{
          return this.wareSelect.endTime?t.getTime()>new Date(this.wareSelect.endTime).getTime()-86400000:false
        }
      },
      endPickerOpts:{
        disabledDate:(t)=>{
          return this.wareSelect.beginTime?t.getTime()<new Date(this.wareSelect.beginTime).getTime():false
        }
      }
    }
  },
  created(){
    this.getWareList()
  },
  methods:{
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res.code==200){
          this.wareList=res.data;
          this.wareSelect={
            wareId:res.data[0].wareId,
            wareType:res.data[0].wareType
          }
          this.getBatchNo();
        }
      })
    },
    wareIdChange(val){
      this.wareList.forEach(item=>{
        if(item.wareId==val){
          this.wareSelect.wareType=item.wareType
        }
      })
      this.getBatchNo()
    },
    getBatchNo(){
      axios.get('/system/grain/getBatchNoSelect',{params:this.wareSelect}).then(res=>{
        if(res.code==200){
          let data=res.data;
          if(data.length>0){
            this.getTempInfo(data[0].grainId)
          }else{
            this.$message({
              type: 'info',
              message: "该仓还未采集粮温",
              duration:1000
            }); 
          }
        }
      })
    },
    getTempInfo(grainId){
      axios.get('/system/grain/'+grainId).then(res=>{
        if(res.code==200){
          let data=res.data;
          let layer=data.mirLayer;
          let row=data.mirRow;
          let column=data.mirColumn;
          let layerList=[{name:"全部",ind:0}];
          let pointList=[];
          let details=data.details;
          if(this.wareSelect.wareType==0){
            for(let i=0;i<layer;i++){
              layerList.push({name:"第 "+(i+1)+" 层",ind:i+1})
              let arr=[];
              for(let j=0;j<row;j++){
                let piont=new Array(column).fill({});
                details.forEach(item=>{
                  if(item.mirLayer==(i+1)&&item.mirRow==(j+1)){
                    piont.fill({value:item.temp,detailId:item.detailId},item.mirColumn-1,item.mirColumn)
                  }
                })
                arr.push(piont)
              }
              pointList.push(arr)
            }
          }else{
            let coilRule=data.data.coilRule.split('-');
            this.siloGen=row;
            this.siloQuan=column;
            for(let i=0;i<layer;i++){
              layerList.push({name:'第 '+(i+1)+' 层',ind:i+1});
              let n=0;
              let arr=[];
              for(let j=0;j<column;j++){
                let piont=new Array(Number(coilRule[j])).fill({});
                if(j>0){
                  n+=Number(coilRule[j-1])
                }
                details.forEach(item=>{
                  if(item.mirLayer==(i+1)&&item.mirColumn==(j+1)){
                    piont.fill({value:item.temp,detailId:item.detailId,gen:Number(item.mirRow)+n},item.mirRow-1,item.mirRow)
                  }
                })
                arr.push(piont)
              }
              pointList.push(arr)
            }
          }
          this.grainLayerList=layerList;
          this.pointList=pointList;
        }
      })
    },
    getLineInfo(detailId){
      if(detailId){
        this.showDatePicker=true;
        this.wareSelect.detailId=detailId
      }else{
        this.$message({
          type: 'error',
          message: "这是一个无效点",
          duration:1000
        }); 
      }
    },
    sureRangTime(){
      this.showLineInfo=true;
      axios.get('/system/grain/pointTemp',{params:this.wareSelect}).then(res=>{
        if(res.code==200){
          this.showDatePicker=false;
          let data=res.data;
          let interval=Math.floor(data.length/20);
          let timelist=data.map(item=>{
            return item.date
          })
          let vallist=data.map(item=>{
            return item.temp
          })
          this.lineTempShow=this.$echarts.init(this.$refs.lineTempShow,null);
          let option={
            grid: {
              top: "10%",
              bottom: "6%",
              left:'3%',
              right:'3%',
              containLabel: true
            },
            tooltip:{trigger:'axis'},
            toolbox: {
              show: true,
              feature: {
                saveAsImage: { show: true }
              }
            },
            title:[{
              left:'center',
              text:'温度变化曲线'
            }],
            visualMap: [{
              show: false,
              type: 'continuous',
              min: -20,
              max: 60,
              inRange: {
                color: ["#01dd26","#f9e600","#fd7c00","#f61005"]
              }
            }],
            calculable : true,
            xAxis : [{
              name:'时间',
              type : 'category',
              data :timelist,
              grid:{
                left:'20%',
                bottom:'38%'
              },
              nameTextStyle:{
                align:'center'
              },
              axisLine: {
                lineStyle: {
                  color: "#1e2d4e"
                },
              },
              axisLabel: {
                fontSize : 12,
                color: "#657c97",
                interval:interval,
                rotate:45
              },
              boundaryGap:false
            }],
            yAxis : [{
              name:'温度(℃)',
              nameTextStyle : {
                  fontSize : 12, 
                  fontFamily : "微软雅黑"
              },
              type: "value",
              scale:'true'
            }],
            series : [{
              name:'温度(℃)',
              type:'line',
              smooth:true,
              showSymbol:false,
              data:vallist
            }]
          }
          this.lineTempShow.setOption(option)
        }
      })
    },
    startDrag($event){
      let that=this;
      // 开始
      let dom=document.querySelector('body');
      dom.style.cursor='move'
      window.onmousemove=function(event){
        if(that.leavalY<-90){
          that.leavalY=-90
        }else if(that.leavalY>90){
          that.leavalY=90
        }else{
          if(that.leavalY==90){
            if(event.movementX<0){
              that.leavalY+=(event.movementX/10)
            }
          }else if(that.leavalY==-90){
            if(event.movementX>0){
              that.leavalY+=(event.movementX/10)
            }
          }else{
            that.leavalY+=(event.movementX/10)
          }
        }
        if(that.leavalX<-90){
          that.leavalX=-90
        }else if(that.leavalX>90){
          that.leavalX=90
        }else{
          if(that.leavalX==90){
            if(event.movementY>0){
              that.leavalX-=(event.movementY/10)
            }
          }else if(that.leavalX==-90){
            if(event.movementY<0){
              that.leavalX-=(event.movementY/10)
            }
          }else{
            that.leavalX-=(event.movementY/10)
          }
        }
      }
      // 停止
      window.onmouseup = function () {
        window.onmousemove = null;
        dom.style.cursor='default'
        return
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .checkLayerWrap{
    height: 50px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 20px;
    border-bottom: 1px solid rgba(0,0,0,0.1)
  }
  .checkLayerWrap .el-form-item{
    margin-bottom: 0 !important;
    font-weight: 500
  }
  .grainDataTable{
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    padding: 10px;
  }
  .allGrain{
    justify-content: flex-start;
  }
  .layerGrain{
    justify-content: center
  }
  .siloGrain{
    justify-content: flex-start;
    align-items: flex-start
  }
  .ceng{
    display: flex;
    flex-direction: column;
    text-align: center;
    border-left: 1px solid rgba(0,0,0,0.1);
    border-top: 1px solid rgba(0,0,0,0.1);
  }
  .layerTitle{
    height: 50px;
    font-weight: 600;
    line-height: 50px;
    border-right: 1px solid rgba(0,0,0,0.1);
    border-top: none
  }
  .cengWrap:first-child .layerTitle{
    border-top: 1px solid rgba(0,0,0,0.1)
  }
  .siloCengWrap{
    border-left: 1px solid rgba(0,0,0,0.1);
    border-top: 1px solid rgba(0,0,0,0.1)
  }
  .siloTabTitle{
    height:40px;
    min-width: 50px;
    flex-shrink: 0;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    border-right: 1px solid rgba(0,0,0,0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box
  }
  .hang{
    display: flex;
  }
  .siloQuan{
    display: flex
  }
  .lie{
    height:40px;
    min-width: 50px;
    max-width: 100px;
    flex-shrink: 0;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    border-right: 1px solid rgba(0,0,0,0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box
  }
  .unitTips{
    position: absolute;
    bottom: 10px;
    left: 10px;
  }
  .grain3DWrap{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    background-color: #F6F7FC;
    display: flex;
    align-items: center;
    justify-content: center;
    perspective: 2000px;
    .check3DLayerWrap{
      position: absolute;
      left: 20px;
      height: 50px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      top: 0;
      z-index: 1000;
      .el-form-item{
        margin-bottom: 0 !important;
        font-weight: 500
      }
    }
    .ware3DWrap{
      height: 400px;
      width: 700px;
      position: relative;
      transform-style: preserve-3d;
      .wareLeftfront{
        width: 10px;
        height: 400px;
        background: #FFFFFF;
        transform: translateZ(200px)
      }
      .wareLeftleft{
        height: 400px;
        width: 400px;
        background: #efefef;
        transform: rotateY(-90deg) translateZ(200px)
      }
      .wareLeftright{
        height: 400px;
        width: 400px;
        background: #efefef;
        transform: rotateY(-90deg) translateZ(190px)
      }
      .wareLefttop{
        width: 10px;
        height: 400px;
        background: #e4e4e4;
        transform: rotateX(90deg) translateZ(200px);
      }
      .wareBackfront{
        width: 700px;
        height: 400px;
        background: #eeecec;
        transform: translateZ(-190px)
      }
      .wareBackright{
        height: 400px;
        width: 10px;
        background: #d8d8d8;
        transform: rotateY(-90deg) translateZ(-695px) translateX(-195px)
      }
      .wareBacktop{
        height: 10px;
        width: 700px;
        background: #e4e4e4;
        transform: rotateX(90deg) translateZ(5px) translateY(-195px);
      }
      .wareBottomtop{
        height: 400px;
        width: 700px;
        background: #e0e0e0;
        transform: rotateX(90deg) translateZ(-200px);
      }
      .wareBottombottom{
        height: 400px;
        width: 700px;
        background: #e0e0e0;
        transform: rotateX(90deg) translateZ(-210px);
      }
      .wareBottomfront{
        width:700px;
        height: 10px;
        transform: translateZ(200px) translateY(400px);
        background:#cdcdcd;
      }
      .wareBottomleft{
        width: 400px;
        height: 10px;
        transform: rotateY(90deg) translateZ(-200px) translateY(400px);
        background: #b6b6b6;
      }
      .wareBottomright{
        width: 400px;
        height: 10px;
        transform: rotateY(90deg) translateZ(500px) translateY(400px);
        background: #b6b6b6;
      }
      .wareRightfront{
        width: 10px;
        height: 400px;
        background: rgba(255, 255, 255, 0.153);
        transform: translateZ(200px) translateX(690px);
      }
      .wareRightright{
        height: 400px;
        width: 400px;
        background: #d8d8d836;
        transform: rotateY(-90deg) translateZ(-500px)
      }
      .wareRighttop{
        width: 10px;
        height: 400px;
        background: #e4e4e431;
        transform: rotateX(90deg) translateZ(200px) translateX(690px);
      }
      .wareToptop{
        width: 700px;
        height: 400px;
        transform: rotateX(90deg) translateZ(200px);
      }
      .wareTopfront{
        width: 700px;
        height: 10px;
        background: #e4e4e42d;
        transform: translateZ(200px)
      }
      .wareDataShow{
        width: 680px;
        height: 390px;
        display: flex;
        flex-direction:column-reverse;
        .dataShowGen{
          flex-grow: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          .dataShowLie{
            flex-grow: 1;
            flex-basis: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #dfdfdf;
            height: 100%;
            padding: 3px;
            box-sizing: border-box;
            .dataShowValue{
              background: #9eacb9;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              color: white
            }
          }
        }
      }
      .isTempDataShow{
        background: #dfdfdf;
      }
      .wareDataShowfront{
        width: 680px;
        height: 10px;
        background: rgba(255, 255, 255, 0.153);
      }
      .iswareDataShowfront{
        background: #b6bfd3;
      }
      .wareDateShowright{
        height: 10px;
        width: 400px;
        background: rgba(255, 255, 255, 0.153);
      }
      .iswareDataShowright{
        background: #c8c8c8;
      }
      .wareCengWrap{
        height: 400px;
        width: 50px;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,0.5);
        transform: translateZ(200px) translateX(-50px);
        justify-content: space-around;
        align-items: center
      }
      .wareLieWrap{
        width:700px;
        height: 20px;
        display: flex;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,0.5);
        transform: translateZ(210px) translateY(410px);
        justify-content: space-around;
        align-items: center;
      }
      .wareHangWrap{
        width: 50px;
        height: 400px;
        transform: rotateX(90deg) translateZ(-200px) translateX(700px);
        display: flex;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,0.5);
        flex-direction:column-reverse;
        justify-content: space-around;
        align-items: center;
      }
      .wareCengItem,.wareHangItem,.wareLieItem{
        display: flex;
        justify-content: center;
        align-items: center;
        padding:2px 5px;
        background: #d6ddff;
        border-radius: 3px;
        white-space: nowrap
      }
    }
    .ware3DWrap>div{
      position: absolute;
      -webkit-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      user-select: none;
    }
    .silo3DWrap{
      height: 400px;
      width: 500px;
      position: relative;
      transform-style: preserve-3d;
      .siloWall{
        height: 400px;
        width: 500px;
        border-left: 1px solid #8d8d8d3b;
        border-right: 1px solid #8d8d8d3b;
      }
      .siloBottom{
        border: 1px solid;
        height: 500px;
        width: 500px;
        border-radius: 50%;
        background: #b6bfd3
      }
      .isNotsiloBottom{
        background:none;
        border: 1px solid rgba(255, 255, 255, 0.23)
      }
      .siloTop{
        border:1px solid rgba(0,0,0,0.1);
        background: #b6bfd317
      }
      .siloDataShow{
        background: #9fc7A1;
        border: none;

      }
      .siloDataShowWarp{
        height: 100%;
        width: 100%;
        border-radius: 50%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .siloDataQuanWrap{
        border: 1px solid white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
      }
      .siloDataQuan{
        position: absolute;
        background-color: rgba(222, 206, 151, 0.53);
        border-radius: 50%;
      }
      .siloDataLie{
        background-color:#2ebf2e;
        height:50px;
        width:50px;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        position: absolute;
        z-index: 2;
        left: 50%;
        top: 0;
        color: white;
        margin: -20px 0 0 -20px;
      }
    }
    .silo3DWrap>div{
      position: absolute;
      -webkit-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      user-select: none;
    }
    #palette{
      position: absolute;
      left: 10px;
      bottom: 10px;
    }
  }
  .grainItemsmall{
    width: 125px;
    height: 75px;
    margin-right: 10px;
    margin-left: 3px;
    margin-top: 10px;
    margin-bottom: 3px;
    .el-checkbox{
      position: absolute;
      left: 5px;
      top: 5px;
      line-height: 0
    }
    .grainWareImgsmall{
      width: 59px;
      height: 41px;
      background-image: url('../../assets/grain/checkWareHouse.png');
      background-size: cover;
      position: absolute;
      bottom: -42px;
      left: 55px;
    }
    .grainSiloImgsmall{
      height: 41px;
      width:33px;
      background-image: url("../../assets/grain/checkSquatSilo.png");
      background-size: cover;
      position: absolute;
      bottom: -42px;
      left: 75px;
    }
    .grainItemsmall .is-checked .grainWareImgsmall{
      background-image: url('../../assets/ware/wareHouse.png');
    }
    .grainItemsmall .is-checked .grainSiloImgsmall{
      background-image: url("../../assets/ware/squatSilo.png");
    }
  }
  .grainWareName{
    font-size: 14px;
    font-weight: 600;
    position: absolute;
    bottom: 10px
  }
  .grainMoreTemp{
    width: 743px !important;
  }
  .grainMoreTemp .dialog-setWrap{
    flex-direction: column;
    padding-right: 0px
  }
  .moreHarvestStatus{
    padding: 10px 0px 20px 10px;
    text-align: end
  }
  .pickerWrap{
    height: 130px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 20px !important
  }
  .lineInfoWrap{
    height: 700px;
    width: 1160px !important;
  }
  .echartLineWrap{
    height: 660px;
    width: 1140px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
